import React, { useEffect, useState } from "react";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { oldDocumentData } from "../../../services/api/user";
import AdminDashboard from "../AdminDashboard/AdminDashboard";
import { GetLocalStorageParsed } from "../../../Utils/Utils";
import { Message } from "../../../components/message";
import { HomeIcon } from "../../../components/Application/ApplicationIcon";
import { BsChevronLeft } from "react-icons/bs";
import { Table } from "react-bootstrap";
import NotFoundTable from "../../../components/notFound/NotFoundTable";

const OldDocumentsAdmin = () => {
  const userDetail = GetLocalStorageParsed("userDetail");
  const [documentData, setDocumentData] = useState(null);
  const location = useLocation();
  const [apiMessage, setApiMessage] = useState({ type: "", message: "" });
  const navigate = useNavigate();
  const [tableDataLoaded, setTableDataLoaded] = useState(false);

  useEffect(() => {
    if (!userDetail) {
      navigate("/");
    } else {
      if (location?.state && location?.state?.data) {
        fetchOldDocumentData(location?.state?.data);
      }
    }
  }, []);

  const fetchOldDocumentData = async (data) => {
    try {
      const formData = new FormData();
      formData.append("unique_id", data?.unique_id);
      const details = await oldDocumentData(formData);
      if (details && details?.categories && details?.categories.length > 0) {
        setDocumentData(details?.categories);
      }
      setTableDataLoaded(true);
    } catch (err) {
      setTableDataLoaded(true);
      setApiMessage({ type: "error", message: err?.message });
    }
  };

  const filteredDocumentData = documentData?.filter(
    (item) => item.files && item.files.length > 0
  );

  // Function to download all files as a ZIP
  const downloadAllFiles = (category) => {
    const zip = new JSZip();
    category.files.forEach((file, index) => {
      zip.file(
        file.name,
        fetch(file.path).then((res) => res.blob())
      );
    });

    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, `${category.category}_files.zip`);
    });
  };

  const formatCategory = (category) => {
    return category
      .split("-") // Split the string by hyphen
      .map(
        (
          word // Capitalize the first letter of each word
        ) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(" "); // Join the words back together with a space
  };

  return (
    <AdminDashboard>
      <div className="aod-outer">
        {apiMessage && (
          <Message
            apiMessage={apiMessage}
            setApiMessage={setApiMessage}
          ></Message>
        )}
        <div className="ap-breadcrumb pt-2 pb-2 mb-2 adm-breadcrumb">
          <div>
            <HomeIcon />
            <b onClick={() => navigate("/admin/")}>Home / </b>
            <span>Old Documents</span>
          </div>
        </div>
        <div className="aod-top user-aod-top mb-3">
          <div className=" text-center mb-2 adm-head">
            <button
              onClick={() => {
                navigate("/admin/old-applications");
              }}
            >
              <BsChevronLeft /> Back
            </button>
          </div>
        </div>
        <div className="aod-bottom">
          <div className="page_heading">
            <h5>Old Documents</h5>
          </div>
          <div className="row">
            <div className="reciept-table table-responsive mt-2">
              <div className="ad-reg-table">
                <Table size="sm" className="ad-cat-table">
                  <thead>
                    <tr role="row">
                      <th>S.No</th>
                      <th>Sub Category</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredDocumentData?.length > 0 ? (
                      filteredDocumentData?.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{formatCategory(item.category)}</td>
                          <td>
                            <Link
                              to="/admin/old-documents-view"
                              state={{ fileData: item.files, categoryData: location?.state?.data }}
                            >
                              <button className="btn admin-theme-btn me-2 mb-2">
                                View Files
                              </button>
                            </Link>
                            <button
                              className="btn admin-theme-btn me-2 mb-2"
                              onClick={() => downloadAllFiles(item)}
                            >
                              Download (Zip)
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : tableDataLoaded ? (
                      <NotFoundTable colSpan="3"></NotFoundTable>
                    ) : (
                      <></>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminDashboard>
  );
};

export default OldDocumentsAdmin;
